// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmationMessage_container__2VVHZ","error":"ConfirmationMessage_error__1BvXO","icon":"ConfirmationMessage_icon__3kpJ9"};